var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 40,
    viewBox: "0 0 123 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5842_332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.252 39.7796H6.73532C3.1212 39.7796 0.191406 36.8605 0.191406 33.2598V6.71121C0.191406 3.11023 3.1212 0.191406 6.73532 0.191406H116.252C119.865 0.191406 122.795 3.11023 122.795 6.71121V33.2598C122.795 36.8605 119.865 39.7796 116.252 39.7796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.83356 10.5205L21.4673 16.857L18.2149 20.0023L8.66992 10.6881C8.96132 10.399 9.42487 10.2989 9.83356 10.5205Z",
    fill: "#0AE577"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2156 20.0022L8.5602 29.3407C8.45047 29.1852 8.38477 28.994 8.38477 28.781V11.3773C8.38477 11.0994 8.49614 10.8598 8.67058 10.688L18.2156 20.0022Z",
    fill: "#40C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8133 19.2229C26.494 19.5931 26.494 20.5653 25.8133 20.9361L21.5504 23.2569L18.2148 20.0023L21.4672 16.8569L25.8133 19.2229Z",
    fill: "#FFC826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5514 23.2571L9.83457 29.6381C9.36905 29.8918 8.83125 29.7252 8.56055 29.3409L18.2159 20.0024L21.5514 23.2571Z",
    fill: "#FF3945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6892 23.3975C43.0561 23.624 41.8061 23.9958 40.329 23.9958C38.6736 23.9958 37.3102 23.5752 36.2389 22.5565C35.2973 21.6508 34.7129 20.1952 34.7129 18.497C34.7293 15.2462 36.9692 12.8691 40.6375 12.8691C41.9037 12.8691 42.8938 13.1438 43.3646 13.3703L43.0236 14.5186C42.4392 14.26 41.7088 14.0495 40.605 14.0495C37.943 14.0495 36.2064 15.6993 36.2064 18.4325C36.2064 21.1978 37.8782 22.8315 40.4266 22.8315C41.3517 22.8315 41.9848 22.7019 42.3094 22.5402V19.2894H40.0856V18.1575H43.6892V23.3975Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.9901 19.9041C52.9901 22.799 50.9773 24.0606 49.0784 24.0606C46.9518 24.0606 45.3125 22.5077 45.3125 20.0334C45.3125 17.4135 47.033 15.877 49.2082 15.877C51.4641 15.877 52.9901 17.5103 52.9901 19.9041ZM46.757 19.985C46.757 21.6992 47.7472 22.9932 49.1431 22.9932C50.5065 22.9932 51.5292 21.7153 51.5292 19.9526C51.5292 18.6265 50.8636 16.9444 49.1756 16.9444C47.4877 16.9444 46.757 18.4969 46.757 19.985Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.9023 19.9041C61.9023 22.799 59.8894 24.0606 57.9902 24.0606C55.864 24.0606 54.2246 22.5077 54.2246 20.0334C54.2246 17.4135 55.9451 15.877 58.1203 15.877C60.3763 15.877 61.9023 17.5103 61.9023 19.9041ZM55.6691 19.985C55.6691 21.6992 56.6593 22.9932 58.0552 22.9932C59.4186 22.9932 60.4413 21.7153 60.4413 19.9526C60.4413 18.6265 59.7757 16.9444 58.0877 16.9444C56.3994 16.9444 55.6691 18.4969 55.6691 19.985Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.4714 16.055C70.4389 16.621 70.4064 17.2517 70.4064 18.2059V22.7506C70.4064 24.5457 70.0492 25.6455 69.2864 26.3247C68.5236 27.0364 67.4197 27.2626 66.4296 27.2626C65.4883 27.2626 64.4495 27.0364 63.8165 26.6157L64.1736 25.5323C64.693 25.8557 65.5044 26.1467 66.4785 26.1467C67.9391 26.1467 69.0104 25.3866 69.0104 23.4135V22.5401H68.9779C68.5397 23.2681 67.6957 23.8501 66.4785 23.8501C64.5307 23.8501 63.1348 22.2007 63.1348 20.0334C63.1348 17.381 64.8714 15.877 66.6733 15.877C68.0367 15.877 68.7834 16.5886 69.1241 17.2357H69.1566L69.2217 16.055H70.4714ZM68.994 19.1441C68.994 18.9015 68.9779 18.691 68.9129 18.4969C68.6533 17.6724 67.9552 16.9928 66.9164 16.9928C65.553 16.9928 64.5793 18.1411 64.5793 19.9526C64.5793 21.4891 65.3582 22.7666 66.9003 22.7666C67.7768 22.7666 68.5722 22.2167 68.8807 21.311C68.9618 21.0684 68.994 20.7935 68.994 20.5509V19.1441Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7773 12.3999H74.2054V23.8824H72.7773V12.3999Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.4024 20.2275C77.435 22.1522 78.6686 22.9444 80.097 22.9444C81.1194 22.9444 81.7364 22.7666 82.2719 22.5401L82.5153 23.5591C82.0123 23.7856 81.1519 24.0442 79.9022 24.0442C77.4836 24.0442 76.0391 22.4593 76.0391 20.0982C76.0391 17.7369 77.435 15.877 79.7235 15.877C82.2883 15.877 82.97 18.1251 82.97 19.5644C82.97 19.8557 82.9374 20.0819 82.9213 20.2275H77.4024ZM81.5902 19.2085C81.6063 18.3031 81.2166 16.8959 79.6098 16.8959C78.1653 16.8959 77.5322 18.222 77.4185 19.2085H81.5902Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.2266 13.1118C88.9083 12.9986 89.8012 12.9014 90.9372 12.9014C92.3331 12.9014 93.3558 13.2251 94.005 13.8071C94.6055 14.3246 94.9627 15.1171 94.9627 16.0876C94.9627 17.0742 94.6706 17.8503 94.1187 18.4163C93.3719 19.2087 92.1547 19.6133 90.7749 19.6133C90.3528 19.6133 89.9635 19.5969 89.6389 19.5161V23.8827H88.2266V13.1118ZM89.6389 18.3681C89.9471 18.449 90.3367 18.4811 90.8075 18.4811C92.5119 18.4811 93.5507 17.6565 93.5507 16.1524C93.5507 14.7128 92.5279 14.0176 90.9698 14.0176C90.3528 14.0176 89.8823 14.066 89.6389 14.1308V18.3681Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7324 12.3999H98.1609V23.8824H96.7324V12.3999Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.914 23.8825L104.801 22.8959H104.752C104.314 23.5107 103.47 24.0606 102.35 24.0606C100.759 24.0606 99.9473 22.9444 99.9473 21.8125C99.9473 19.9202 101.636 18.8851 104.671 18.9015V18.7395C104.671 18.0927 104.492 16.9283 102.885 16.9283C102.155 16.9283 101.392 17.1549 100.84 17.5103L100.516 16.5725C101.165 16.1519 102.106 15.877 103.096 15.877C105.499 15.877 106.083 17.5103 106.083 19.0792V22.0066C106.083 22.6858 106.115 23.349 106.213 23.8825H104.914ZM104.703 19.8878C103.145 19.8557 101.376 20.1306 101.376 21.6508C101.376 22.5725 101.992 23.0092 102.723 23.0092C103.745 23.0092 104.395 22.3624 104.622 21.6992C104.671 21.5535 104.703 21.3918 104.703 21.2465V19.8878Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.777 16.0552L110.498 20.6804C110.676 21.1979 110.871 21.8126 111.001 22.2817H111.033C111.179 21.8126 111.342 21.2143 111.537 20.6483L113.095 16.0552H114.604L112.462 21.6346C111.439 24.3193 110.741 25.6941 109.767 26.535C109.069 27.1494 108.371 27.3923 108.014 27.4568L107.657 26.2601C108.014 26.1468 108.485 25.9203 108.907 25.5645C109.296 25.2575 109.784 24.7075 110.108 23.9799C110.173 23.8342 110.222 23.721 110.222 23.6401C110.222 23.5593 110.189 23.446 110.124 23.2683L107.219 16.0552H108.777Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5842_332"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 123,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStore);
export default __webpack_public_path__ + "static/media/play-store.50fda553c928978c421f4760759c644a.svg";
export { ForwardRef as ReactComponent };